const isoToDate = iso => {
  const part = iso.substring(0,10);
  const parts = part.split('-');
  const date = `${parts[2]}/${parts[1]}/${parts[0]}`;

  return date;
};

export default isoToDate;
